import Head from "next/head";

import { EnterPage } from "@fwa/src/components/EnterPage";
import sharedStyles from "@fwa/src/components/styles.module.css";

const Enter = () => (
  <>
    <Head>
      <title>Log in to Cancer Reasearch UK Giving Pages</title>
    </Head>

    <div className={sharedStyles["content-max-width"]}>
      <EnterPage />
    </div>
  </>
);

export default Enter;
